import React, { useState, useEffect } from 'react';
import {
  Card,
  Form,
  Input,
  Button,
  message,
  Typography,
  Space,
  Divider,
  Alert
} from 'antd';
import { MailOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../../utils/request';

const { Title, Text } = Typography;

const Settings: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/settings');
      form.setFieldsValue({
        notification_email: response.data.notification_email || ''
      });
    } catch (error: any) {
      message.error('获取设置失败');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (values: any) => {
    setSaving(true);
    try {
      await axios.post('/api/settings/batch', {
        settings: [
          {
            key: 'notification_email',
            value: values.notification_email,
            description: '核销通知接收邮箱'
          }
        ]
      });
      message.success('设置已保存');
    } catch (error: any) {
      message.error(error.response?.data?.message || '保存失败');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <Title level={3}>系统设置</Title>

      <Card loading={loading} style={{ maxWidth: 600 }}>
        <Title level={4}>
          <MailOutlined style={{ marginRight: 8 }} />
          邮件通知设置
        </Title>

        <Alert
          message="核销通知"
          description="当销售员完成优惠券核销后，系统会自动发送邮件通知到下方设置的邮箱地址。邮件内容包含优惠券名称、优惠码、EKOK号码、客人姓名、销售姓名和核销时间。"
          type="info"
          showIcon
          style={{ marginBottom: 24 }}
        />

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
        >
          <Form.Item
            name="notification_email"
            label="核销通知接收邮箱"
            rules={[
              {
                validator: (_, value) => {
                  if (!value || value.trim() === '') {
                    return Promise.resolve();
                  }
                  const emails = value.split(',').map((e: string) => e.trim());
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  for (const email of emails) {
                    if (email && !emailRegex.test(email)) {
                      return Promise.reject(new Error(`邮箱格式不正确: ${email}`));
                    }
                  }
                  return Promise.resolve();
                }
              }
            ]}
            extra="留空则不发送通知邮件。支持多个邮箱，用英文逗号分隔。"
          >
            <Input
              placeholder="例如: manager@example.com, admin@example.com"
              prefix={<MailOutlined />}
              style={{ width: '100%' }}
            />
          </Form.Item>

          <Divider />

          <Form.Item>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                icon={<SaveOutlined />}
                loading={saving}
              >
                保存设置
              </Button>
            </Space>
          </Form.Item>
        </Form>

        <Divider />

        <div>
          <Text type="secondary">
            <strong>发件邮箱:</strong> noreply@wanguo.co.nz
          </Text>
          <br />
          <Text type="secondary" style={{ fontSize: 12 }}>
            注意: 邮件发送功能需要在服务器端配置 SMTP 密码才能正常工作。
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default Settings;
